<div
  [formGroup]="_form()"
  [attr.id]="mElementId()"
  [ngStyle]="mElementStyles()"
  [class]="mElementStyleClasses()"
  [class.m-readonly]="readonly()"
  [class.m-disabled]="disabled()"
  class="m-position:relative"
>
  <myre-dropdown
    #optionPicker
    theme="custom"
    [wrapPanel]="false"
    [disableSearch]="true"
    [closeOnSelect]="false"
    emptyListPlaceholder=""
    [ngStyle]="panelStyle()"
    [list]="selectableOptions()"
    [placeholder]="defaultLabel()"
    [ngClass]="panelStyleClass()"
    [formControlName]="_keys.Option"
    [listStyle]="{ paddingBlock: hasTypes() ? null : '0' }"
    labelStyleClass="m-flex-items:center"
    [labelStyle]="{
      paddingBlock: '0',
      paddingInlineEnd: optionPicker.isFocused() ? '0.5rem' : '',
    }"
    (onBlur)="_onOptionClose()"
    (onFocus)="_onOptionOpen()"
    (onSelect)="_onOptionChange($event)"
  >
    <!-- Selected Item -->
    <ng-template [dropdownTemplate]="'selectedItem'" let-isOpen="isOpen">
      @if (labelTemplate()) {
        <ng-container
          *ngTemplateOutlet="labelTemplate().template; context: _context()"
        />
      } @else {
        <div
          class="m-flex m-flex-justify:between m-flex-items:center m-gap:2 m-size:full"
        >
          <span
            class="m-text-ellipsis"
            [class.m-text-color:neutral]="!hasValue()"
          >
            {{ defaultLabel() }}
          </span>
          <i
            [class]="'myre-icon-arrow_' + (isOpen ? 'dropup' : 'dropdown')"
          ></i>
        </div>
      }
    </ng-template>

    <ng-template [dropdownTemplate]="'empty'" />

    <!-- Types -->
    @if (hasTypes()) {
      <ng-template [dropdownTemplate]="'header'">
        <div class="m-flex m-flex-column m-width:full">
          <div class="m-flex m-width:full m-padding:4">
            <myre-dropdown
              #typePicker
              [list]="types()"
              [readonly]="!types().length"
              [placeholder]="typesLabel()"
              [formControlName]="_keys.Type"
            />
          </div>

          @if (hasOptions()) {
            <div class="m-width:full m-border-t m-border-color:grey-pale"></div>
          }
        </div>
      </ng-template>
    }

    <!-- Date fields -->
    <ng-template [dropdownTemplate]="'footer'">
      @if (hasOptions() || hasTypes()) {
        <div class="m-width:full m-border-t m-border-color:grey-pale"></div>
      }
      <div
        [formGroupName]="_keys.Range"
        class="m-flex m-flex-column m-gap:4 m-padding:4 m-width:full"
      >
        <div class="m-flex m-flex-column m-gap:2">
          <myui-label
            class="m-width:full"
            [label]="startDateLabel()"
            elementStyleClass="m-width:full"
          >
            <myre-date-picker
              class="m-width:full"
              [formControlName]="_keys.From"
              [max]="_rangeEnd()"
              [error]="showErrors() && _hasRangeErrors()"
              (change)="_onRangeChange($event)"
            />
          </myui-label>
        </div>

        <div class="m-flex m-flex-column m-gap:2">
          <myui-label
            class="m-width:full"
            [label]="endDateLabel()"
            elementStyleClass="m-width:full"
          >
            <myre-date-picker
              class="m-width:full"
              [formControlName]="_keys.To"
              [min]="_rangeStart()"
              [error]="showErrors() && _hasRangeErrors()"
              (change)="_onRangeChange($event)"
            />
          </myui-label>
        </div>

        @if (showErrors() && _hasRangeErrors()) {
          <myui-hint-list [hints]="_rangeErrors()">
            <ng-template [mTemplate]="'item'" let-text>
              <span>{{ _error(text) }}</span>
            </ng-template>
          </myui-hint-list>
        }

        <myre-button
          elementStyleClass="m-width:full"
          [disabled]="isFormPristine() || !isFormValid()"
          (onClick)="onApply()"
        >
          {{ actionLabel() }}
        </myre-button>
      </div>
    </ng-template>
  </myre-dropdown>
</div>
